import {configureStore} from '@reduxjs/toolkit';

import usersReducer from './features/users/usersSlice';
import authReducer from './features/users/auth';
import productsReducer from './features/products/productsSlice';
import productImagesReducer from './features/products/productImagesSlice';
import categoriesReducer from './features/categories/categoriesSlice';
import suppliersReducer from './features/suppliers/suppliersSlice';
import clientsReducer from './features/clients/clientsSlice';
import brandsReducer from './features/brands/brandsSlice';
import couriersReducer from './features/couriers/couriersSlice';
import ordersReducer from './features/orders/ordersSlice';
import claimsReducer from './features/claims/claimsSlice';
import userPointsReducer from './features/userPoints/userPointsSlice';
import clientUsersReducer from './features/clientUsers/clientUsersSlice';
import invoicesReducer from './features/invoices/invoicesSlice';
import purchaseOrdersReducer from './features/purchaseOrders/purchaseOrdersSlice';
import reportsReducer from './features/reports/reportsSlice';
import snackbarReducer from './features/snackbar/snackbarSlice';




const store = configureStore({
  reducer: {
    auth: authReducer,
    brands: brandsReducer,
    categories: categoriesReducer,
    clients: clientsReducer,
    couriers: couriersReducer,
    products: productsReducer,
    productImages: productImagesReducer,
    reports: reportsReducer,
    snackbar: snackbarReducer,
    suppliers: suppliersReducer,
    orders: ordersReducer,
    claims: claimsReducer,
    userPoints: userPointsReducer,
    clientUsers: clientUsersReducer,
    invoices: invoicesReducer,
    purchaseOrders: purchaseOrdersReducer,
    users: usersReducer,
  },
});

export default store;
